<div class="performance-trend-container" [ngStyle]="containerStyle">
  <span class="value-text" [ngStyle]="valueStyle">{{ value }} </span>
  <span class="score-bar" *ngIf="includeScoreBar">
    <div class="score-container">
      <div class="score-cover" [ngStyle]="{'width': value}"></div>
    </div>
  </span>
  <span *ngIf="trend.display" class="trend-chip" [ngClass]="[trend.status, trend.size, trend.statusColor]" [ngStyle]="trendStyle">
    <app-arrow-icon *ngIf="trend.direction" [direction]="trend.direction" [color]="trend.status" [size]="trend.size"></app-arrow-icon>
    <span>{{ trend.display }}</span>
  </span>
</div>